import axiosConfig from '../modules/axiosConfig'
import utils from '../modules/utils'

const HTTP = axiosConfig.HTTP

const state = {
  code: '',
  loading: false,
  error: '',
  errorDescription: ''
}

// getters
const getters = {
  getDeleteTpvData: state => state.code
}

// actions
const actions = {
  async deleteTpv ({ commit, rootState }, data) {
    const config = rootState.appConfig.configFile

    try {
      const storageAppData = JSON.parse(sessionStorage.getItem('appParams'))
      const storageAppToken = sessionStorage.getItem('token')
      const hashToken = utils.SHA256(storageAppData.entidad + storageAppToken + storageAppData.canal)
      let body = {}
      body = Object.assign({}, {
        runService: {
          opData: {
            avanzar: false,
            businesstimeout: '',
            canal: storageAppData.canal,
            claveFin: '',
            claveInicio: '',
            entidad: storageAppData.entidad,
            idioma: 'ES',
            indMasDatos: '',
            oficina: '',
            pantPagina: '',
            retroceder: false,
            mainUser: storageAppData.mainUser,
            securityToken: hashToken
          },
          eEntrada: {
            codcom: data.codcom,
            codterm: data.codterm
          }
        }
      })
      commit('DELETETPVS_REQUEST_STARTED', true)
      const response = await HTTP.post(config.endpoints.deleteTPVS, body)
      sessionStorage.setItem('token', response.data.runServiceResponse.return.securityToken)
      if (response.status === 200) {
        switch (response.data.runServiceResponse.return.retorno) {
          case '000':
            response.error = false
            commit('DELETETPVS_REQUEST_SUCCEED', response.data.runServiceResponse.return)
            break
          case '039':
            response.error = true
            commit('DELETETPVS_REQUEST_FAILED', response.data.runServiceResponse.return)
            break
          case 102:
            response.error = false
            response.vacio = true
            commit('DELETETPVS_REQUEST_FAILED', response.data.runServiceResponse.return)
            break
          case 200:
            response.error = true
            commit('DELETETPVS_REQUEST_FAILED', response.data.runServiceResponse.return)
            break
          case 210:
            response.error = false
            commit('DELETETPVS_REQUEST_FAILED', response.data.runServiceResponse.return)
            break
          case 220:
            response.error = true
            commit('DELETETPVS_REQUEST_FAILED', response.data.runServiceResponse.return)
            break
          default:
            response.error = true
            commit('DELETETPVS_REQUEST_FAILED', response.data.runServiceResponse.return)
            break
        }
      }
      commit('DELETETPVS_REQUEST_FINISHED', false)
      return response
    } catch (error) {
      return error
    }
  },
  loader ({ commit }, actions) {
    commit('SET_LOADER', actions)
  }
}

// mutations
const mutations = {
  'SET_LOADER' (state, actions) {
    state.loading = actions.loader === true
    state.isPasswordText = actions.password === true
  },
  'DELETETPVS_REQUEST_STARTED' (state, payload) {
    state.loading = payload
  },
  'DELETETPVS_REQUEST_FINISHED' (state, payload) {
    state.loading = payload
  },
  'DELETETPVS_REQUEST_SUCCEED' (state, payload) {
    state.error = false
    state.errorDescription = ''
  },
  'DELETETPVS_REQUEST_FAILED' (state, payload) {
    if (payload.retorno === 200) {
      state.errorDescription = 'Error ejecución de servicio'
    } else if (payload.retorno === 220) {
      state.errorDescription = 'Error técnico'
    } else if (payload.retorno === '039') {
      state.errorDescription = 'Sesión expirada'
    } else if (payload.retorno === 102) {
      state.errorDescription = 'No se encontraron datos para los criterios de selección'
    } else if (payload.retorno === 210) {
      state.errorDescription = 'No se encontraron datos para los criterios de selección'
    }
    state.error = true
    state.code = ''
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
